// extracted by mini-css-extract-plugin
module.exports = {"linkLarge":"LinkLarge_linkLarge__Fub06","label":"LinkLarge_label__gQ7We","customIcon":"LinkLarge_customIcon__5Z5rC"};